import React, { useMemo, useState } from "react";
import { Section } from "../ui/Section";
import styles from "../../styles/evento-detalle.module.css";

const getNombrePersona = (persona, p) => {
    if (persona) return `${persona.nombre} ${persona.apellidos}`.trim();
    return p.personaId ?? "—";
};

const getHabitacionesLabel = (p) =>
    (p.habitaciones || []).map((h) => h?.nombre).filter(Boolean).join(", ") || "—";

const pickNotas = (persona) =>
    persona?.comentarios ??
    "";


const pickAlergenos = (persona, p) => {
    const arr =
        (persona?.alergenos && Array.isArray(persona.alergenos) ? persona.alergenos : null) ??
        (p?.alergenos && Array.isArray(p.alergenos) ? p.alergenos : null) ??
        [];

    // Normaliza a strings
    return arr
        .map((a) => a?.alergenoDescripcion || a?.descripcion || a?.nombre || String(a))
        .filter(Boolean);
};



export function TabParticipantes({ evento, personas = [], participacionesOrdenadas }) {
    const parts = Array.isArray(participacionesOrdenadas)
        ? participacionesOrdenadas
        : (Array.isArray(evento?.participaciones) ? evento.participaciones : []);

    // Control de "ver más" por participación (key: id)
    const [expanded, setExpanded] = useState({});

    const toggleExpanded = (key) =>
        setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

    return (
        <Section aside={<span className={styles.chip}>{parts.length} participante(s)</span>}>
            {parts.length === 0 ? (
                <div className={styles.hint}>Este evento no tiene participantes.</div>
            ) : (
                <div className={styles["responsive-table"]}>
                    <table>
                        <thead>
                            <tr>
                                <th>Persona</th>
                                <th className={styles["col-hab"]}>Hab.</th>
                                <th>Alérgenos</th>
                                <th>Notas</th>
                            </tr>
                        </thead>

                        <tbody>
                            {parts.map((p, idx) => {
                                const key = p.id ?? `p-${idx}`;
                                const persona =
                                    p.persona || personas.find((x) => x.id === p.personaId);

                                const nombre = getNombrePersona(persona, p);
                                const habsLabel = getHabitacionesLabel(p);
                                const alergenos = pickAlergenos(persona, p);
                                const notas = String(pickNotas(persona) || "").trim();
                                const isLong = notas.length > 160;
                                const isOpen = !!expanded[key];

                                return (
                                    <tr key={key}>
                                        <td data-label="Persona">{nombre}</td>

                                        <td data-label="Hab." className={styles["col-hab"]}>
                                            <span className={styles["hab-pill"]}>{habsLabel}</span>
                                        </td>

                                        <td data-label="Alérgenos">
                                            {alergenos.length === 0 ? (
                                                "—"
                                            ) : (
                                                <div>
                                                    {alergenos.map((a, i) => (
                                                        <span key={`${key}-al-${i}`} className={styles.chip}>
                                                            {a}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                        </td>

                                        <td data-label="Notas">
                                            {notas ? (
                                                <div className={styles["notes-wrap"]}>
                                                    <div
                                                        className={`${styles["notes-text"]} ${!isOpen ? styles["notes-clamp"] : ""
                                                            }`}
                                                        title={!isOpen && isLong ? notas : undefined}
                                                    >
                                                        {notas}
                                                    </div>

                                                    {isLong && (
                                                        <button
                                                            type="button"
                                                            className={styles["link-btn"]}
                                                            onClick={() => toggleExpanded(key)}
                                                        >
                                                            {isOpen ? "Ver menos" : "Ver más"}
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                "—"
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </Section>
    );
}
